module.exports = __webpack_public_path__ + "static/media/cvmns.590b7112.jpg";